import React from 'react';
import { keyMap } from '@locales/lokalise/keyMap';
import { CONSTANTS } from 'components/shared/constants';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { MamInvestorTerminateLPOAQForm } from './mamInvestorTerminateLPOAQForm';

interface IMamInvestorTerminateLPOAProps {
  accountId: number;
}

const MamInvestorTerminateLPOA = ({ accountId }: IMamInvestorTerminateLPOAProps) => {
  return (
    <div className="tabs__form">
      <MamInvestorTerminateLPOAQForm
        tradingAccountId={accountId}
        withoutVerify={true}
        qFormType={CONSTANTS.Q_FORM_TYPE.MAM_INVESTOR}
        title={keyMap.partnershipMamInvestorTitle}
      />
    </div>
  );
};

export default withErrorBoundary(MamInvestorTerminateLPOA);
